import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import './NotFound.scss';

export default function NotFound() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const isProductNotFound = searchParams.has('product');
  const fallbackDestination = '/';
  const fromPage = isProductNotFound ? t('common.product') : t('common.page');
  const fallbackDestinationName = t('common.products');

  return (
    <div className="app-body">
      <div className="view-content-container">
        <section className="page-not-found-container">
          <img
            src="./patch_emptybox.svg"
            alt={t('common.page_not_found.title', { fromPage })}
          />
          <section id="prodNotFoundText">
            <h1>{t('common.page_not_found.title', { fromPage })}</h1>
            <p>
              {t('common.page_not_found.main_text', {
                fromPage: fromPage.toLocaleLowerCase(),
              })}
            </p>
            <Link to={fallbackDestination}>
              <button type="button" className="btn btn-primary">
                {t('common.page_not_found.button_text', {
                  fallbackDestinationName,
                })}
              </button>
            </Link>
          </section>
        </section>
      </div>
    </div>
  );
}
